import {css} from '@emotion/react'
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import {prism} from 'react-syntax-highlighter/dist/esm/styles/prism'

const cssCode = css({
    'code': {
        whiteSpace: 'pre-wrap !important',
    },
})

export default function Code({children, ...props}) {
    return (
        <SyntaxHighlighter
            css={cssCode}
            style={prism}
            PreTag="div"
            wrapLines
            {...props}
        >
            {String(children).replace(/\n$/, '')}
        </SyntaxHighlighter>
    )
}
